import { PM_PROVIDERS } from 'common/constants/constants';
import { pmFiltersBuilder } from 'components/FilterMenus/pm.filters';
import { useSelector } from 'react-redux';
import { isPmToolAzureBoardsSelector } from 'state/selectors/sensors-authorizations';
import { FILTER_TYPES } from 'common/constants/filters';

const useMenuItems = ({ customFields, getSettingOrDefinitionValue }) => {
  const isPmToolAzureBoards = useSelector(isPmToolAzureBoardsSelector);

  const SUPPORTED_TYPES = {
    ISSUE_TYPES: {
      id: FILTER_TYPES.ISSUE_TYPES,
      title: isPmToolAzureBoards ? 'Work Items Types' : 'Issue Types'
    },
    CUSTOM_FIELDS: {
      id: FILTER_TYPES.FIELD,
      title: isPmToolAzureBoards ? 'Fields' : 'Custom Fields',
      header: 'Select Field'
    },
    LABELS: {
      id: FILTER_TYPES.LABEL,
      title: isPmToolAzureBoards ? 'Tags' : 'Labels',
      header: `Select ${isPmToolAzureBoards ? 'Tag' : 'Label'}`
    },
    KEYWORDS: {
      id: FILTER_TYPES.KEYWORDS,
      title: 'Keywords',
      header: 'Select keywords',
      isFreeInputs: true
    }
  };

  const defaultMenuItems = [
    SUPPORTED_TYPES.ISSUE_TYPES,
    SUPPORTED_TYPES.LABELS,
    SUPPORTED_TYPES.CUSTOM_FIELDS,
    SUPPORTED_TYPES.KEYWORDS
  ];

  const SupportedTypesIds = [
    FILTER_TYPES.ISSUE_TYPES,
    FILTER_TYPES.LABEL,
    FILTER_TYPES.FIELD,
    FILTER_TYPES.KEYWORDS
  ];

  const menuItemsV2 = pmFiltersBuilder(
    {
      [PM_PROVIDERS.JIRA]: SupportedTypesIds,
      [PM_PROVIDERS.AZURE_BOARDS]: SupportedTypesIds
    },
    getSettingOrDefinitionValue
  );

  const customFieldsMapper = {
    ...customFields.reduce((acc, obj) => ({ ...acc, [obj.id]: obj.title }), {}),
    [FILTER_TYPES.ISSUE_TYPES]: SUPPORTED_TYPES.ISSUE_TYPES.title,
    [FILTER_TYPES.LABEL]: SUPPORTED_TYPES.LABELS.title
  };

  return {
    menuItems: defaultMenuItems,
    customFieldsMapper,
    menuItemsV2
  };
};

export default useMenuItems;
